import React, {useState} from 'react';
import {Divider} from 'primereact/divider';
import AppCard from '../../../components/ui/AppCard';
import InfoField from '../../../components/ui/InfoField';
import StatusBadge from '../../../components/ui/StatusBadge';
import {useMountEffect} from 'primereact/hooks';
import {Skeleton} from 'primereact/skeleton';
import {Accordion, AccordionTab} from 'primereact/accordion';
import {Button} from 'primereact/button';
import paymentImage from "../../../assets/images/patterns/loans-bg.png";
import {getMyClaims} from '../../../services/claims-service';

const getStatusTone = (statusValue) => {
    if (!statusValue) return "warning";
    const value = statusValue.toLowerCase();
    if (value.includes("approved") || value.includes("paid")) return "success";
    if (value.includes("reject") || value.includes("denied")) return "danger";
    return "warning";
};

export default function ClaimsList() {
    const [claims, setClaims] = useState(null);
    const [loading, setLoading] = useState(true);

    useMountEffect(() => {
        getClaims();
    }, []);

    const getClaims = async () => {
        setLoading(true);
        try {
            const response = await getMyClaims();
            if (response.data?.status === "SUCCESS") {
                const rawClaims = response.data.responseBody || [];
                const mappedClaims = rawClaims.map(c => ({
                    claimId: c.referenceNumber || c.id,
                    status: c.claimStatus || c.status,
                    policyNumber: c.policyNumber,
                    incidentDate: c.deceased?.dateOfDeath || 'N/A',
                    dateSubmitted: c.createdAt ? new Date(c.createdAt).toLocaleDateString() : 'N/A',
                    notes: c.notes || 'No notes available'
                }));
                setClaims(mappedClaims);
            } else {
                setClaims([]);
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error('Error fetching claims details:', error);
            setClaims([]);
        }
    };

    return (
        <div className="flex flex-col h-full w-full">
            <div className="w-full">
                <div className="w-full">
                    {loading ? (
                        <div className="border-round border-1 surface-border p-4 surface-card">
                            <div className="flex mb-3">
                                <Skeleton shape="circle" size="4rem" className="mr-2"></Skeleton>
                                <div>
                                    <Skeleton width="10rem" className="mb-2"></Skeleton>
                                    <Skeleton width="5rem" className="mb-2"></Skeleton>
                                    <Skeleton height=".5rem"></Skeleton>
                                </div>
                            </div>
                            <Skeleton width="100%" height="150px"></Skeleton>
                            <div className="flex justify-content-between mt-3">
                                <Skeleton width="4rem" height="2rem"></Skeleton>
                                <Skeleton width="4rem" height="2rem"></Skeleton>
                            </div>
                        </div>
                    ) : (
                        <>
                            {(claims?.length > 0) ? (
                                <div className="col-xxl-12 col-xl-12 col-lg-12">
                                    <AppCard headerImg={paymentImage} >
                                        <div className="invite-content">
                                            <div className="mb-4">
                                                <span className="badge badge-info bg-blue-100 text-blue-700 border-none badge-sm uppercase font-bold mb-3 px-3 py-3 rounded-full tracking-wider text-xs">Claims</span>
                                                <h2 className="text-2xl font-extrabold text-base-content mb-2 tracking-tight">Your Claims</h2>
                                                <p className="text-sm text-base-content/70">Track the status of your claims.</p>
                                            </div>
                                            <Divider type="solid" className="opacity-30 my-4" />

                                            <Accordion activeIndex={0}>
                                                {claims.map((record, indexNo) => (
                                                    <AccordionTab active header={"Claim " + (indexNo + 1)} key={record.claimId}>
                                                        <div className="w-full">
                                                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
                                                                <InfoField label="Claim ID" value={record.claimId} />
                                                                <InfoField label="Status" value={<StatusBadge tone={getStatusTone(record.status)} label={record.status} />} />
                                                                <InfoField label="Policy Number" value={record.policyNumber} />
                                                                <InfoField label="Incident Date" value={record.incidentDate} />
                                                                <InfoField label="Date Submitted" value={record.dateSubmitted} />
                                                                <InfoField label="Notes" value={record.notes} />
                                                            </div>
                                                            <div className="flex justify-content-end mt-4">
                                                                <Button
                                                                    label="View Documents"
                                                                    icon="pi pi-file"
                                                                    className="btn btn-primary btn-outline p-button-outlined"
                                                                    rounded
                                                                    onClick={() => window.location.href=`/claims/view/${record.claimId}`}
                                                                />
                                                            </div>
                                                        </div>
                                                    </AccordionTab>
                                                ))}
                                            </Accordion>
                                        </div>
                                    </AppCard>
                                </div>
                            ) : (
                                <AppCard>
                                    <div className="text-center p-4">
                                        <h4>No Claims Found</h4>
                                        <p>You have not submitted any claims yet.</p>
                                    </div>
                                </AppCard>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
